import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { Row, Col } from 'antd';
import { FormOutlined } from '@ant-design/icons';

import { IDeliveryGroup } from '../../../../../../../models/Shopping';
import { updateProductsDeliveryDate } from '../../../../../../../../slices/OrderSummary/orderSummarySlice';
import { formatStandardDate, momentFormat } from '../../../../../../../../utils/data-format-enchanters/datetime-enchanter';
import { useProduct } from '../../../../../../../hooks/useProduct';

import './bv-delivery-group.scss';

import BVDeliveryGroupCard from './components/BVDeliveryGroupCard/bv-delivery-group-card';
import BVDatePicker from '../../../../../../BVControls/BVDatePicker/bv-date-picker';

interface IBVShoppingDateGroup {
    customerFacilityId: number;
    deliveryGroup: IDeliveryGroup;
    disabled: boolean;
}

const BVShoppingDateGroup: React.FunctionComponent<IBVShoppingDateGroup> = ({ customerFacilityId, deliveryGroup, disabled }) => {
    const {
        handleProductsAvailableDate,
        productsAvailableDate,
        productsAvailableDateLoading
    } = useProduct();

    const dispatch = useDispatch();

    const _handleDeliveryChange = (date: any) => {
        dispatch(updateProductsDeliveryDate({
            deliveryDate: date ? new Date(date).toISOString() : undefined,
            ids: _.map(deliveryGroup.products, x => x.rowId || -1)
        }));

        setDeliveryGroupActive(false);
    }

    const [deliveryGroupActive, setDeliveryGroupActive] = useState<boolean>(false);

    const productsIds = _.map(deliveryGroup.products, x => x.id || -1);

    return (
        <div className="bv-delivery-group-container">
            <div className="delivery-heading">
                {deliveryGroupActive
                    ?
                    <React.Fragment>
                        <BVDatePicker
                            properties={{
                                placeholder: 'Shipping date...',
                                disabled: productsAvailableDateLoading,
                                disabledDate: (current: any) => current && current < moment(productsAvailableDate).subtract(1, 'days').endOf('day'),
                                format: momentFormat,
                                loading: productsAvailableDateLoading,
                                value: deliveryGroup.deliveryDate && moment(formatStandardDate(deliveryGroup.deliveryDate), momentFormat),
                                onOpenChange: (open: boolean) => open && handleProductsAvailableDate(productsIds, customerFacilityId),
                                onChange: (date: any, dateString: string) => _handleDeliveryChange(date)
                            }}
                        />

                        <span className="delivery-heading-action" onClick={() => setDeliveryGroupActive(false)}>
                            Cancel
                        </span>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        {deliveryGroup.deliveryDate ? formatStandardDate(deliveryGroup.deliveryDate) : '-'}

                        {!disabled &&
                            <FormOutlined className="delivery-heading-icon" onClick={() => setDeliveryGroupActive(true)} />
                        }
                    </React.Fragment>
                }
            </div>

            <Row gutter={[24, 24]}>
                {_.map(deliveryGroup.products, (dataItem, dataIndex) => (
                    <Col key={dataIndex} span={6}>
                        <BVDeliveryGroupCard disabled={disabled} orderProduct={dataItem} />
                    </Col>
                ))}
            </Row>
        </div>
    );
}

export default BVShoppingDateGroup;